export enum RouteEnum {
  // -------------------------------------------- authorization
  SIGN_IN = '/login/sign-in',
  SIGN_UP = '/login/sign-up',
  FORGOT_PASSWORD = '/login/forgot-password',
  // -------------------------------------------- dashboard
  DASHBOARD = '/dashboard',
  SUBSCRIPTION = '/subscription',
  SETTINGS = '/settings',
  USERS = '/users',
  MENTORS = '/mentors',
  ROLES = '/roles',
  PERMISSIONS = '/permissions',
  TENANT_LIST = '/tenant-list',
}